<template>
  <styled-multiselect
    v-model="selectedVgbk"
    :label="getLabel"
    :loading="isFetchingVgbks"
    :options="vgbks"
    :placeholder="$t('vgbkSelect.selectVgbk')"
  ></styled-multiselect>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';
  import StyledMultiselect from '@/components/StyledMultiselect/StyledMultiselect.vue';
  import { IVgbkListElementDto } from 'types';
  import { VgbkService } from '@/services';
  import { GlobalUtils } from '@/mixins/globalUtils';

  export default defineComponent({
    name: 'VgbkSelect',
    components: { StyledMultiselect },
    props: {
      projectId: {
        type: String,
        required: true,
      },
      modelValue: {
        type: Object as () => IVgbkListElementDto | null,
        default: null,
      },
    },
    emits: ['update:modelValue'],
    data(): {
      isFetchingVgbks: boolean;
      selectedVgbk: IVgbkListElementDto | null;
      vgbks: IVgbkListElementDto[];
    } {
      return {
        isFetchingVgbks: false,
        selectedVgbk: null,
        vgbks: [],
      };
    },
    watch: {
      modelValue(newValue: IVgbkListElementDto | null) {
        this.selectedVgbk = newValue;
      },
      selectedVgbk(newValue: IVgbkListElementDto | null) {
        this.$emit('update:modelValue', newValue);
      },
    },
    mounted() {
      this.fetchVgbks();
    },
    methods: {
      async fetchVgbks() {
        try {
          this.isFetchingVgbks = true;
          this.vgbks = await VgbkService.getVgbkListForProject(this.projectId);
        } catch {
          (this as unknown as GlobalUtils).createErrorToast(
            this.$t('vgbkSelect.errors.errorGettingVgbk'),
          );
        } finally {
          this.isFetchingVgbks = false;
        }
      },
      getLabel(vgbkObject: IVgbkListElementDto): string {
        return `${vgbkObject.designation} - ${vgbkObject.class} (${this.$t(
          'generic.count',
        )} ${vgbkObject.kksCount})`;
      },
    },
  });
</script>

<style lang="scss" scoped>
  .multiselect {
    width: 100%;
  }
</style>
